import React, { useMemo, useContext } from 'react';

/**
 * @ignore - internal component.
 */
var Context = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  Context.displayName = 'ListContext';
}
var ListContextProvider = function ListContextProvider(props) {
  var variant = props.variant,
    dense = props.dense,
    children = props.children;
  var context = useMemo(function () {
    return {
      variant: variant,
      dense: dense
    };
  }, [dense, variant]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
};
var useListContext = function useListContext() {
  return useContext(Context);
};

export { ListContextProvider, useListContext };
//# sourceMappingURL=list-context.esm.js.map
